export function refineEditorShell(): void {
  const shell = document.querySelector<HTMLElement>('.editor-shell');
  const actions = document.querySelector('.top-actions');
  if (!shell || !actions) return;
  const menu = document.createElement('details');
  menu.className = 'editor-more';
  menu.innerHTML =
    '<summary aria-label="More editor actions">More <span aria-hidden="true">⌄</span></summary><div class="editor-more-menu"></div>';
  const contents = menu.querySelector('div')!;
  ['setupBtn', 'shareBtn', 'healthBtn', 'helpBtn', 'commandBtn'].forEach((id) => {
    const button = document.getElementById(id);
    if (button) contents.append(button);
  });
  if (!contents.querySelector('#toggleClientViewBtn')) {
    const clientToggle = document.createElement('button');
    clientToggle.type = 'button';
    clientToggle.id = 'toggleClientViewBtn';
    clientToggle.className = 'client-view-toggle';
    clientToggle.innerHTML =
      '<svg class="btn-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg><span>Preview client mode</span>';
    contents.append(clientToggle);
  }
  actions.insertBefore(menu, document.getElementById('previewBtn'));
  contents.addEventListener('click', (event) => {
    if (
      (event.target as Element).closest('button') &&
      !(event.target as Element).closest('[data-editing-experience]')
    )
      menu.open = false;
  });
  document.addEventListener('pointerdown', (event) => {
    if (!menu.contains(event.target as Node)) menu.open = false;
  });
  menu.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    }
  });

  for (const [side, selector, label] of [
    ['left', '.left-rail', 'Tools'],
    ['right', '.inspector', 'Inspector'],
  ] as const) {
    const panel = shell.querySelector<HTMLElement>(selector)!;
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'desktop-panel-toggle';
    toggle.textContent = label;
    toggle.setAttribute('aria-label', `Toggle ${label.toLowerCase()} panel`);
    toggle.setAttribute('aria-expanded', 'true');
    actions.insertBefore(toggle, menu);
    toggle.onclick = () => {
      const collapsed = shell.classList.toggle(`${side}-collapsed`);
      toggle.setAttribute('aria-expanded', String(!collapsed));
    };
    panel
      .querySelectorAll<HTMLButtonElement>('.panel-heading button[title="Close panel"]')
      .forEach((button) => (button.onclick = () => toggle.click()));
    if (side === 'left')
      panel.querySelectorAll('.rail-tab').forEach((tab) =>
        tab.addEventListener('click', () => {
          shell.classList.remove('left-collapsed');
          toggle.setAttribute('aria-expanded', 'true');
        }),
      );
    const handle = document.createElement('div');
    handle.className = `panel-resizer ${side}-resizer`;
    handle.tabIndex = 0;
    handle.setAttribute('role', 'separator');
    handle.setAttribute('aria-orientation', 'vertical');
    handle.setAttribute('aria-label', `Resize ${label.toLowerCase()} panel`);
    const setWidth = (value: number) => {
      const width = Math.max(240, Math.min(420, value));
      shell.style.setProperty(`--${side}-panel-width`, `${width}px`);
      handle.setAttribute('aria-valuenow', String(width));
      try {
        localStorage.setItem(`webkiln-${side}-panel-width`, String(width));
      } catch {
        /* Preferences are optional. */
      }
    };
    handle.setAttribute('aria-valuemin', '240');
    handle.setAttribute('aria-valuemax', '420');
    let saved = 280;
    try {
      saved = Number(localStorage.getItem(`webkiln-${side}-panel-width`)) || 280;
    } catch {
      /* Use the default. */
    }
    setWidth(saved);
    handle.onkeydown = (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const current = Number(handle.getAttribute('aria-valuenow'));
      setWidth(
        event.key === 'Home'
          ? 240
          : event.key === 'End'
            ? 420
            : current + (event.key === 'ArrowRight' ? 20 : -20) * (side === 'left' ? 1 : -1),
      );
    };
    handle.onpointerdown = (event) => {
      if (event.button !== 0) return;
      event.preventDefault();
      handle.setPointerCapture(event.pointerId);
      const start = event.clientX,
        width = panel.getBoundingClientRect().width;
      shell.classList.add('resizing-panels');
      handle.onpointermove = (move) =>
        setWidth(width + (move.clientX - start) * (side === 'left' ? 1 : -1));
      const finish = () => {
        shell.classList.remove('resizing-panels');
        handle.onpointermove = null;
      };
      handle.onpointerup = finish;
      handle.onlostpointercapture = finish;
    };
    (side === 'right' ? shell : panel).append(handle);
  }
}
